export default {
  title: 'Informações de pagamento verificadas',
  description: 'As suas informações de pagamento foram verificadas com sucesso.',
};
